import { HttpApi, OpenApi } from "@effect/platform";
import * as Groups from "./groups";
export const Api = HttpApi.make("dash-api").annotate(OpenApi.Title, "Superwall Dashboard API").annotate(OpenApi.Description, "API for the Superwall Dashboard").annotate(OpenApi.Servers, [
    {
        url: "https://superwall.com",
        description: "Production"
    },
    {
        url: "https://superwall.dev",
        description: "Staging"
    },
    {
        url: "http://localhost:3000",
        description: "Local"
    },
    {
        url: "/",
        description: "Docs"
    }
]).add(Groups.UsersV1).add(Groups.ApplicationsV1).add(Groups.ClientV1).add(Groups.PaywallsV1).add(Groups.WebPaywallsV1).add(Groups.BlogV1).add(Groups.ChartsV1).add(Groups.CampaignsV1).add(Groups.ProjectsV1).prefix("/dash-api");
